import settings from "../../settings";
import style from "../../settings/map-style.json";

import { $1 } from "../../utilities/selector";

import LoadManager, { QUEUE } from "../load-manager"
import {loadResource} from "../optimisations/async-resource-manager";

const defaults = {
  lat: 0,
  lng: 0,
  z: 2
};

const API_KEY = "AIzaSyAbgl2g23LIdT23sCMopfmbEsWYsE-wXxo";
const API_URL = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`;

export class Map {
  static getMarker(el) {
    return {
      icon: el.getAttribute("data-icon"),
      title: el.getAttribute("data-title"),
      address: el.getAttribute("data-address"),
      position: {
        lat: parseFloat(el.getAttribute("data-lat")),
        lng: parseFloat(el.getAttribute("data-lng")),
      },
      content: el.innerHTML
    };
  }

  static markerAction() {
    if ( ! this instanceof google.maps.Marker )
      throw new Error("`this` was not a MapMarker");

    this.map.setCenter(this.getPosition());
    
    if ( this.infoWindow ) {
      this.infoWindow.open(this.map, this);
    }
  }

  static disableMarker(marker) {
    marker.instance.setMap(null);
  }

  constructor(el) {
    this.el = el || $1("[data-js=map]");
    this.ready = false;
    
    if (!this.el) 
      return;
    
    this.init = this.init.bind(this);
    this.boundsChanged = this.boundsChanged.bind(this);
    
    this.fixedZoom = this.el.getAttribute("data-fixed-zoom");
    this.center = {
      lat: parseFloat(this.el.getAttribute("data-lat")) || defaults.lat,
      lng: parseFloat(this.el.getAttribute("data-lng")) || defaults.lng
    };
    this.zoom = parseInt(this.el.getAttribute("data-zoom")) || defaults.z;
    this.pin = this.el.getAttribute("data-pin");

    this.markers = [...this.el.children]    
      .filter(x => x.hasAttribute("data-lat") && x.hasAttribute("data-lng"))
      .map(Map.getMarker, this);

    LoadManager.queue(() => {
      // Ensures we always have the API before we initialise the map
      loadResource(API_URL).then(this.init)
    }, QUEUE.RESOURCES);
  }

  init() {
    let desktop = (window.innerWidth >= settings.breakpoints.desktop);
    this.bounds = new google.maps.LatLngBounds();

    this.map = new google.maps.Map(this.el, {
      center: this.center,
      zoom: this.zoom,
      mapTypeControl: false,
      scrollwheel: false,
      styles: style,
      disableDefaultUI: !desktop,
      disableDoubleClickZoom: !desktop,
      fullscreenControl: desktop,
      draggable: desktop
    });

    this.map.addListener("bounds_changed", this.boundsChanged)

    this.markers.forEach(this.addMarker, this);
    if (this.markers.length > 1) {
      this.map.fitBounds(this.bounds);
    }

    this.ready = true;
    this.el.dispatchEvent(new CustomEvent("ready", {
      detail: {
        map: this.map
      }
    }))
  }

  addMarker(item) {
    item.map = this.map;

    item.instance = new google.maps.Marker(item);

    if ( item.content ) {
      item.instance.infoWindow = new google.maps.InfoWindow({
        content: item.content
      });
    }

    this.bounds.extend(item.position);

    item.instance.addListener("click", Map.markerAction);
  }

  setMarkers(markers) {
    this.clearMarkers();
    this.markers = markers;
    this.markers.forEach(this.addMarker, this);
    this.map.fitBounds(this.bounds);
  }

  clearMarkers() {
    this.markers.forEach(Map.disableMarker, this);
    this.markers = [];
  }

  boundsChanged() {
    if (!this.fixedZoom && this.map.getZoom() > this.zoom) {
      this.map.setZoom(this.zoom);
      this.fixedZoom = true;
    }
  }
}

export default LoadManager.queue(() => new Map(), QUEUE.DOM);



// WEBPACK FOOTER //
// ./scripts/components/html/map.js